import { render, staticRenderFns } from "./merchantInfoDetails.vue?vue&type=template&id=14590576&scoped=true&"
import script from "./merchantInfoDetails.vue?vue&type=script&lang=js&"
export * from "./merchantInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./merchantInfoDetails.vue?vue&type=style&index=0&id=14590576&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14590576",
  null
  
)

export default component.exports